import {
  osName,
  isTablet,
  osVersion,
  isMobileOnly,
  mobileVendor,
  mobileModel,
} from 'react-device-detect'

import { isPlainObject } from 'is-plain-object'

import { createEndpointUrl } from './createEndpointUrl'
import { EndpointSpecInterface } from './Endpoint'
import { NetworkContextDefaults } from './NetworkProvider'

export type EndpointProviderDefaults = Pick<
  NetworkContextDefaults,
  'baseUrl' | 'platform' | 'version'
> &
  Omit<RequestInit, 'method' | 'body'>

export type DeviceType = 'smartphone' | 'tablet' | 'desktop'

export const getDeviceType = (): DeviceType | undefined => {
  if (isMobileOnly) {
    return 'smartphone'
  }

  if (isTablet) {
    return 'tablet'
  }

  if (!isMobileOnly && !isTablet) {
    return 'desktop'
  }
}

export const convertEndpointProviderToFetchArgs =
  ({
    version,
    platform = 'web',
    baseUrl,
    ...defaults
  }: EndpointProviderDefaults) =>
  ({
    method,
    url,
    data,
    query,
    arrayInFormatWithDuplicatedKeys,
  }: EndpointSpecInterface) => {
    const isDataValid = data && isPlainObject(data)
    const opts = {
      ...defaults,
      method: (method || '').toUpperCase(),
      body: isDataValid ? JSON.stringify(data) : undefined,
      headers: {
        Accept: 'application/json, text/plain, */*',
        ...(isDataValid ? { 'Content-Type': 'application/json' } : {}),
        'SL-Version': version,
        'SL-Platform': platform,
        'SL-Device': getDeviceType(),
        'SL-Device-Details':
          getDeviceType() === 'desktop'
            ? `${osName} ${osVersion}`
            : `${mobileModel} (${mobileVendor})`,
        ...(defaults.headers || {}),
      },
    }

    return [
      createEndpointUrl(url, query, {
        baseUrl,
        arrayInFormatWithDuplicatedKeys,
      }),
      opts as RequestInit,
    ] as const
  }
